// Cadastro simples de contatos (nome + telefone, tabela `clientes` da API). Vivia em
// /clientes até 22/09/2026, quando esse caminho virou o menu de clientes (usuários
// de nível operador com tipo_usuario = cliente). Continua fora da barra lateral.
import React, { useEffect, useState } from 'react';
import http from 'services/http';
import { alerta } from 'components/Alert/index';
import Pagination from 'components/Paginacao';
import 'components/Paginacao/style.css';

const pageSize = 20; // mesmo valor do backend (paginate(20))

export default function Contatos(props) {
    const [filtroNome, setFiltroNome] = useState('');
    const [filtroTelefone, setFiltroTelefone] = useState('');

    const [clientes, setClientes] = useState([]);
    const [total, setTotal] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(true);

    // Sempre que um filtro muda, volta pra página 1.
    useEffect(() => {
        setCurrentPage(1);
    }, [filtroNome, filtroTelefone]);

    // Busca com debounce — evita uma requisição por tecla digitada.
    useEffect(() => {
        let ativo = true;
        const debounce = setTimeout(() => {
            setLoading(true);
            http.get('/clientes', {
                params: { page: currentPage, nome: filtroNome || undefined, telefone: filtroTelefone || undefined },
            })
                .then(({ data: { data: paginator } }) => {
                    if (!ativo) return;
                    setClientes(paginator.data ?? []);
                    setTotal(paginator.total ?? 0);
                })
                .catch((e) => {
                    if (ativo) alerta(e.response?.data ?? { success: false, message: 'Erro ao listar contatos.' });
                })
                .finally(() => { if (ativo) setLoading(false); });
        }, 350);
        return () => { ativo = false; clearTimeout(debounce); };
    }, [currentPage, filtroNome, filtroTelefone]);

    const mudarPagina = (page) => {
        setCurrentPage(page);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <>
            <div className="titulo-principal d-flex justify-content-between align-items-center">
                <span>Contatos</span>
                <button
                    type="button"
                    className="btn btn-sm btn-success"
                    onClick={() => props.history.push('/contatos/novo')}
                >
                    Novo Contato
                </button>
            </div>

            <div className="conteudo-principal d-flex duas-colunas">
                <input
                    type="text"
                    className="form-control"
                    placeholder="Filtrar por nome"
                    value={filtroNome}
                    onChange={(e) => setFiltroNome(e.target.value)}
                />
                <input
                    type="text"
                    className="form-control"
                    placeholder="Filtrar por telefone"
                    value={filtroTelefone}
                    onChange={(e) => setFiltroTelefone(e.target.value)}
                />
            </div>

            <div className="conteudo-principal p-0">
                {loading ? (
                    <div className="p-4 text-center">Carregando...</div>
                ) : (
                    <table className="table table-sm text-center border mb-0 align-middle">
                        <thead className="thead-light">
                            <tr>
                                <th>Nome</th>
                                <th>Telefone</th>
                            </tr>
                        </thead>
                        <tbody>
                            {clientes.length === 0 ? (
                                <tr>
                                    <td colSpan="2" className="text-muted p-4">Nenhum contato cadastrado.</td>
                                </tr>
                            ) : clientes.map((c) => (
                                <tr key={c.id}>
                                    <td className="text-left" style={{ fontWeight: 600 }}>{c.nome}</td>
                                    <td>{c.telefone}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}

                {!loading && total > pageSize && (
                    <div className="d-flex justify-content-center py-2">
                        <Pagination
                            currentPage={currentPage}
                            totalCount={total}
                            pageSize={pageSize}
                            onPageChange={mudarPagina}
                        />
                    </div>
                )}
            </div>
        </>
    );
}
